<div class="mat-typography">
    <table>
        <tr>
            <th>
                Field
            </th>

            <th>
                Current Value
            </th>

            <th>
                Desired Value
            </th>

            <th>
                Status
            </th>
        </tr>

        <tr>
            <td>
                Modern Authentication Protocols

                <mat-icon matTooltip="Modern authentication provides more secure user authentication and authorization, based on OAuth 2.0 and claims-based authentication. Setting this to 'Enforced' (LegacyAuthProtocolsEnabled = false) helps protect your SharePoint Online resources by requiring modern authentication methods and blocking legacy protocols that are more vulnerable to security threats.">info</mat-icon>
            </td>

            <td>
                <ng-container *ngTemplateOutlet="validatorRef"></ng-container>
            </td>

            <td>
                <ng-container *ngTemplateOutlet="formRef"></ng-container>
            </td>

            <td>
                <sway-baseline-status [errors]="errors"></sway-baseline-status>
            </td>
        </tr>
    </table>
</div>

<ng-template #validatorRef>
    <div class="validator">
        {{
        !data.LegacyAuthProtocolsEnabled
        ? "Enforced"
        : "Not Enforced"
        }}
    </div>
</ng-template>

<ng-template #formRef>
    <div class="form">
        <div class="field boolean">
            <mat-form-field appearance="fill">
                <mat-label>Status</mat-label>
                <mat-select [formControl]="control">
                    <mat-option value="any">Ignore</mat-option>
                    <mat-option [value]="false">Enforced</mat-option>
                    <mat-option [value]="true">Not Enforced</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>
</ng-template>
